import Model, {ModelErrors} from "./Model";
import UserModel, { create as createUser, UserModelData } from "./UserModel";

export interface HouseholdMemberData {
  id: number;
  user_id: number;
  role: string;
  created: string;
  updated: string;
  _embedded?: {
    user: UserModelData,
  };
}

export default class HouseholdMemberModel extends Model<HouseholdMemberData> {
  user?: UserModel;

  constructor(data?: HouseholdMemberData, errors?: ModelErrors) {
    super(data, errors);

    if (data?._embedded?.user) {
      this.user = createUser(data._embedded.user);
    }
  }
}


export function create(data?: HouseholdMemberData, errors?: ModelErrors): HouseholdMemberModel {
  return new HouseholdMemberModel(data, errors);
}
